var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"lg","spinner-variant":"customer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }